import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';

export default class Impact extends Scene {
	
	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

		this.addAnimation({
			targets: this.elContainer.querySelector('.huge-impact'),
			duration: 1500,
			delay: 100,
			scale: [0, 1],
			easing: 'easeOutQuad',
		});
	}

}
